import { Link } from 'react-router-dom';
import { articlePreviews } from '@/mocks/articles';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ArticlePreviews() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
            Sugargoo Spreadsheet Articles & Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our collection of in-depth guides, reviews, and shopping strategies. Every article is written to help you shop smarter and save money.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlePreviews.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              className="group flex flex-col bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-white/90 backdrop-blur-sm text-foreground-700 px-2.5 py-1 rounded-full font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 mb-4 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-100">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                    <span>{article.date}</span>
                  </div>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read More
                    <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/sugargoo-spreadsheet-guide"
            className="inline-flex items-center gap-2 border border-primary-300 text-primary-600 hover:bg-primary-50 font-medium text-sm px-6 py-3 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View All Articles
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}